module.exports = __webpack_public_path__ + "static/media/logo-dark.1bd78b0a.svg";